import { EntityType } from './entity-type';
import { InvestmentJurisdiction } from './investment-jurisdiction';
import { ResidencyJurisdiction } from './residency-jurisdiction';

export class Country {
  countryId!: number;
  regionId!: number;
  code!: string;
  name!: string;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  entityTypes!: EntityType[];
  investmentJurisdictions!: InvestmentJurisdiction[];
  region!: string;
  residencyJurisdictions!: ResidencyJurisdiction[];
}
